import { createContext } from 'react'

const dialogContext = createContext()

export default dialogContext
